<router-outlet id="69040DB7-0A79"/>
<lib-alert />
<lib-dialog></lib-dialog>
<lib-temporary-auth-modal></lib-temporary-auth-modal>
@if (!isAdminScope) {
  <lib-modal-expiration/>
}
